import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import { BoxProps, TypographyProps } from '@material-ui/core';
import { Trans, useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';

import { FoodProgramH2 } from 'static_pages/foodProgram/Utils';
import Container from 'system/components/Container';

const ADVANTAGES = [
  {
    highlightKey: 'numericHighlights.empoyer.highlight',
    descriptionKey: 'numericHighlights.empoyer.description',
  },
  {
    highlightKey: 'numericHighlights.fastGrowth.highlight',
    descriptionKey: 'numericHighlights.fastGrowth.description',
  },
  {
    highlightKey: 'numericHighlights.office.highlight',
    descriptionKey: 'numericHighlights.office.description',
  },
];

const NumericHighlights = (props: BoxProps) => {
  const theme = useTheme();
  const { t } = useTranslation('food_program');

  return (
    <Box as="section" {...props}>
      <Box py={6} textAlign="center" bgcolor={theme.palette.grey[100]}>
        <Container size="sm">
          <FoodProgramH2 mb={6}>
            <Trans
              t={t}
              i18nKey="numericHighlights.title"
              components={[
                <Box key="1" as="span" color={theme.palette.secondary[400]} />,
              ]}
            />
          </FoodProgramH2>
        </Container>
        <Container size="md">
          <Advantages>
            {ADVANTAGES.map(({ highlightKey, descriptionKey }) => (
              <Advantage key={highlightKey}>
                <AdvantageHighlight>{t(highlightKey)}</AdvantageHighlight>
                <AdvantageDescription>
                  <Trans
                    t={t}
                    i18nKey={descriptionKey}
                    components={[<strong key="1" />]}
                  />
                </AdvantageDescription>
              </Advantage>
            ))}
          </Advantages>
        </Container>
      </Box>
    </Box>
  );
};

const Advantages = styled.div`
  display: flex;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(3)}px;

  flex-direction: column;
  align-items: center;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    flex-direction: row;
    gap: ${({ theme }) => theme.spacing(9)}px;
    align-items: flex-start;
  }
`;

const Advantage = styled.div`
  max-width: 300px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)}px;
`;

const AdvantageHighlight = (props: TypographyProps) => (
  <Typography
    lineHeight={{ xs: 1.5, sm: 1 }}
    fontSize={{ xs: 40, md: 70 }}
    fontWeight={700}
    {...props}
  />
);

const AdvantageDescription = (props: TypographyProps) => (
  <Typography fontSize={16} {...props} />
);

export default NumericHighlights;
